/**
 * From http://www.angulartutorial.net/2014/04/angular-js-auto-focus-for-input-box.html
 * @todo make this a class
 */

export default angular.module("focus", [])
  .directive("focus", function ($timeout) {
    return {
      scope: {
        // See https://stackoverflow.com/questions/14050195/what-is-the-difference-between-and-in-directive-scope-in-angularjs?rq=1
        // for the difference between @, =, and &.
        trigger: "=focus"
      },
      link: function (scope, element) {
        scope.$watch("trigger", function (value) {
          if (value) {
            $timeout(function () {
              element[0].focus();
            });
          }
        });
      }
    };
  })
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/autofocus.directive.js
 **/